(function() {
  function initTieredDiscounts() {
    const box = document.querySelector('[data-tiered-box]');
    if (!box) return;

    const cards = box.querySelectorAll('.tshirt-tier-card');

    cards.forEach(function(card) {
      card.addEventListener('click', function() {
        cards.forEach(c => c.classList.remove('is-active'));
        card.classList.add('is-active');

        const radio = card.querySelector('.tshirt-tier-radio');
        if (radio) radio.checked = true;

        const qty = parseInt(card.getAttribute('data-qty'), 10) || 1;

        // Update all quantity inputs on the product page
        const allQtyInputs = document.querySelectorAll('input[name="quantity"], [data-product-form-quantity], .quantity__input');
        allQtyInputs.forEach(input => {
          input.value = qty;
        });

        // Set or update line item property for tier bundle
        const form = document.querySelector('form[action*="/cart/add"], product-form form');
        if (form) {
          let propInput = form.querySelector('input[name="properties[Fırsat]"]');
          if (qty > 1) {
            if (!propInput) {
              propInput = document.createElement('input');
              propInput.type = 'hidden';
              propInput.name = 'properties[Fırsat]';
              form.appendChild(propInput);
            }
            propInput.value = qty === 2 ? '2 Adet (%10 İndirimli Paket)' : '3 Adet (%20 İndirimli Paket)';
          } else {
            if (propInput) {
              propInput.remove();
            }
          }
        }
      });
    });

    // Variant change listener to update base and discounted prices
    document.addEventListener('variant:change', function(e) {
      if (e.detail && e.detail.variant) {
        const basePrice = e.detail.variant.price; // in cents

        function formatMoney(cents) {
          return '$' + (cents / 100).toFixed(2);
        }

        const price1 = box.querySelector('[data-tier-price="1"]');
        const price2 = box.querySelector('[data-tier-price="2"]');
        const price3 = box.querySelector('[data-tier-price="3"]');

        if (price1) price1.textContent = formatMoney(basePrice);
        if (price2) price2.textContent = formatMoney(basePrice * 0.90 * 2);
        if (price3) price3.textContent = formatMoney(basePrice * 0.80 * 3);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTieredDiscounts);
  } else {
    initTieredDiscounts();
  }
})();
